export const clients = {
  main: "Clients",
};
